'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.updateCart = exports.removeLoneMiniDeodorant = exports.cartUpdatePack = exports.cartRemovePack = exports.cartRemove = exports.cartChange = exports.cartUpdate = exports.cartAddViaPermalink = exports.cartAddMultiple = exports.cartAdd = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _CartCodes = require('scripts/components/CartCodes');

var _Klaviyo = require('scripts/components/Klaviyo');

var _Modal = require('scripts/components/Modal');

var _Helpers = require('scripts/components/Helpers');

var _Cart = require('scripts/modules/Cart');

var _Upsell = require('scripts/components/Upsell');

var _SubscriptionUpsell = require('scripts/components/SubscriptionUpsell');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dom = {
  body: 'body',
  addToCart: '[add-to-cart]',
  addPackToCart: '[add-pack-to-cart]',
  addMultipleToCart: '[add-multi-to-cart]',
  propertyInput: '[name^="properties"]',
  cartItemCount: '[cart-item-count]',
  cartPrice: '[cart-price]'
};

// Modules


// Components


var isCartTemplate = function isCartTemplate() {
  return $(dom.body).hasClass('template__cart');
};

var isProductTemplate = function isProductTemplate() {
  return window.bva.template == 'product';
};

var cartAdd = exports.cartAdd = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var skipGlobalUpdate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var options;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (id) {
              _context.next = 2;
              break;
            }

            throw new Error('[BVA] Missing Variant ID');

          case 2:
            options = { id: id, quantity: quantity, properties: properties };
            _context.next = 5;
            return fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(options)
            }).then(function (resp) {
              return resp.json();
            }).then(function (cart) {
              if (typeof cart.token === 'undefined') {
                return getCart(skipGlobalUpdate);
              }
              if (!skipGlobalUpdate) {
                applyGlobalCartState(cart);
              }
              return cart;
            });

          case 5:
            return _context.abrupt('return', _context.sent);

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function cartAdd() {
    return _ref.apply(this, arguments);
  };
}();

var cartAddMultiple = exports.cartAddMultiple = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var skipGlobalUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (items) {
              _context2.next = 2;
              break;
            }

            throw new Error('[BVA] Missing Add Items');

          case 2:
            _context2.next = 4;
            return fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items: items })
            }).then(function (resp) {
              return resp.json();
            }).then(function (cart) {
              if (typeof cart.token === 'undefined') {
                return getCart(skipGlobalUpdate);
              }
              if (!skipGlobalUpdate) {
                applyGlobalCartState(cart);
              }
              return cart;
            });

          case 4:
            return _context2.abrupt('return', _context2.sent);

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function cartAddMultiple() {
    return _ref2.apply(this, arguments);
  };
}();

var cartAddViaPermalink = exports.cartAddViaPermalink = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
    var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var permalink;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!ids || !ids.length)) {
              _context3.next = 2;
              break;
            }

            throw new Error('[BVA] Missing Pack Variant IDs');

          case 2:
            permalink = buildCartPermalink(ids, quantity, properties);
            return _context3.abrupt('return', fetch(permalink, {
              method: 'GET',
              credentials: 'same-origin',
              headers: {
                'content-Type': 'application/json'
              }
            }).then(function () {
              return getCart();
            }));

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function cartAddViaPermalink() {
    return _ref3.apply(this, arguments);
  };
}();

var cartUpdate = exports.cartUpdate = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
    var updates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var skipGlobalUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (updates) {
              _context4.next = 2;
              break;
            }

            throw new Error('[BVA] Missing Cart Update Map');

          case 2:
            _context4.next = 4;
            return fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ updates: updates })
            }).then(function (resp) {
              return resp.json();
            }).then(function (cart) {
              if (typeof cart.token === 'undefined') {
                return getCart(skipGlobalUpdate);
              }
              if (!skipGlobalUpdate) {
                applyGlobalCartState(cart);
              }
              return cart;
            });

          case 4:
            return _context4.abrupt('return', _context4.sent);

          case 5:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function cartUpdate() {
    return _ref4.apply(this, arguments);
  };
}();

var cartChange = exports.cartChange = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var skipGlobalUpdate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var options;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (key) {
              _context5.next = 2;
              break;
            }

            throw new Error('[BVA] Missing Line Item Key/ID For Change');

          case 2:
            if (typeof key === 'number') key = key.toString();
            options = {};

            if (key.length > 2) options['id'] = key;else options['line'] = key;
            if (quantity) options['quantity'] = quantity;
            if (properties) options['properties'] = properties;
            _context5.next = 9;
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(options)
            }).then(function (resp) {
              return resp.json();
            }).then(function (cart) {
              if (typeof cart.token === 'undefined') {
                return getCart(skipGlobalUpdate);
              }
              if (!skipGlobalUpdate) {
                applyGlobalCartState(cart);
              }
              return cart;
            });

          case 9:
            return _context5.abrupt('return', _context5.sent);

          case 10:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined);
  }));

  return function cartChange() {
    return _ref5.apply(this, arguments);
  };
}();

var cartRemove = exports.cartRemove = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var skipGlobalUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return cartUpdate((0, _defineProperty3.default)({}, key, 0), skipGlobalUpdate);

          case 2:
            return _context6.abrupt('return', _context6.sent);

          case 3:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, undefined);
  }));

  return function cartRemove() {
    return _ref6.apply(this, arguments);
  };
}();

var getCart = function () {
  var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
    var skipGlobalUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return fetch('/cart.js', {
              method: 'GET',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(function (resp) {
              return resp.json();
            }).then(function (cart) {
              if (!skipGlobalUpdate) {
                applyGlobalCartState(cart);
              }
              return cart;
            });

          case 2:
            return _context7.abrupt('return', _context7.sent);

          case 3:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, undefined);
  }));

  return function getCart() {
    return _ref7.apply(this, arguments);
  };
}();

var cartAddPack = function () {
  var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
    var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var uniqueIds, items;
    return _regenerator2.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (ids.length) {
              _context8.next = 2;
              break;
            }

            throw new Error('[BVA] Missing Pack Variant IDs');

          case 2:
            if (!(typeof properties == 'undefined')) {
              _context8.next = 4;
              break;
            }

            throw new Error('[BVA] Missing Pack Properties');

          case 4:
            uniqueIds = [].concat((0, _toConsumableArray3.default)(new Set(ids)));
            items = uniqueIds.map(function (id) {
              // Check if this id is included in the pack multiple times (i.e byp w/ 2 or 3 of same scent)
              var uniqueQty = ids.reduce(function (qty, currentId) {
                if (currentId === id) qty++;
                return qty;
              }, 0);
              // Multiply by form qty to get the true total
              var qty = uniqueQty * quantity;

              return {
                id: id,
                quantity: qty,
                properties: properties
              };
            });
            return _context8.abrupt('return', cartAddMultiple(items));

          case 7:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, undefined);
  }));

  return function cartAddPack() {
    return _ref8.apply(this, arguments);
  };
}();

var cartRemovePack = exports.cartRemovePack = function () {
  var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9() {
    var packId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var updates;
    return _regenerator2.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (packId) {
              _context9.next = 2;
              break;
            }

            throw new Error('[BVA] Missing Pack ID For Remove');

          case 2:
            updates = window.bva.cart.items.reduce(function (map, item, index) {
              // only remove items that are pack items and are part of the pack being removed
              if (item.properties != null && item.properties.hasOwnProperty('pack_id')) {
                if (item.properties.pack_id == packId) {
                  map['' + item.key] = 0;
                }
              }
              return map;
            }, {});
            _context9.next = 5;
            return cartUpdate(updates);

          case 5:
            return _context9.abrupt('return', _context9.sent);

          case 6:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, undefined);
  }));

  return function cartRemovePack() {
    return _ref9.apply(this, arguments);
  };
}();

var getPackItems = function getPackItems(packId) {
  return window.bva.cart.items.filter(function (item, index) {
    if (item.properties != null && item.properties.hasOwnProperty('pack_id')) {
      if (item.properties.pack_id == packId) {
        return item;
      }
    }
  });
};

var cartUpdatePack = exports.cartUpdatePack = function () {
  var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(packId, quantity) {
    var packItems, updates;
    return _regenerator2.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            packItems = getPackItems(packId);

            if (packItems.length) {
              _context10.next = 3;
              break;
            }

            throw new Error('[BVA] No Pack Items Found with PackID: ' + packId);

          case 3:
            updates = packItems.reduce(function (updates, item, index) {
              var productType = item.product_type.toLowerCase();
              var productVendor = item.vendor.toLowerCase();
              var isPackParent = item.price === 0;
              var isBYP = productType.indexOf('byp') !== -1 || productVendor.indexOf('byp') !== -1;
              var isSoap = productType.indexOf('bar soap single') !== -1 || productType.indexOf('bar soap - set') !== -1;
              var newQuantity = quantity;

              // BYP
              if (!isPackParent && isBYP) {
                var count = item.properties.pack_count;
                // pack with 3 of the same inner items
                if (count == 2) {
                  newQuantity *= 3;
                  // pack with 3 inner items, 2 of which are the same
                } else if (count == 3) {
                  var hasHigherQty = packItems.every(function (packItem) {
                    if (item.id !== packItem.id) {
                      return item.quantity > packItem.quantity;
                    }
                    return true;
                  });
                  if (hasHigherQty) {
                    newQuantity *= 2;
                  }
                }
                // Soaps
              } else if (isSoap) {
                if (!isPackParent && !isBYP) {
                  newQuantity = quantity * 2;
                }
              }
              updates[item.key] = newQuantity;
              return updates;
            }, {});
            return _context10.abrupt('return', cartUpdate(updates));

          case 5:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, undefined);
  }));

  return function cartUpdatePack(_x23, _x24) {
    return _ref10.apply(this, arguments);
  };
}();

var getProperties = function getProperties($form, properties) {
  var props = properties || {};
  var purchaseType = $form.find('[name="purchase_type"]:checked').val();
  var isSubscription = purchaseType == 'autodeliver' ? true : false;

  if ($form.find(dom.propertyInput).length) {
    $form.find(dom.propertyInput).each(function () {
      var isRadio = $(this).is(':radio');
      var isChecked = $(this).is(':checked');
      var isRechargeInput = $(this).hasClass('is-recharge-input');
      var name = $(this).attr('name').replace('properties[', '').replace(']', '');
      var value = $(this).val();
      if (isRadio && !isChecked) {
        return;
      }
      if (!isRechargeInput || isRechargeInput && isSubscription) {
        props[name] = value;
      }
    });
  }

  if (props.hasOwnProperty('subscription_id')) {
    if (!props.subscription_id || props.subscription_id === 'false') {
      delete props.subscription_id;
      delete props.shipping_interval_frequency;
      delete props.shipping_interval_unit_type;
    }
  }
  return props;
};

var applyGlobalCartState = function applyGlobalCartState(cart) {
  window.bva.cart = cart;
  var event = new CustomEvent('cart.updated', { detail: cart });
  document.dispatchEvent(event);
};

var ATCEventGA = function ATCEventGA(state, $form) {
  var purchaseType = isProductTemplate() ? $form.find('[name="purchase_type"]:checked').length > 0 ? $form.find('[name="purchase_type"]:checked').val() : 'onetime' : 'onetime';
  var purchaseLength = purchaseType == 'autodeliver' ? $form.find('[name="properties[shipping_interval_frequency]"]').val() : 'onetime';
  var purchaseVariant = $form.find(dom.addToCart).attr('data-variant-id') || $form.find(dom.addPackToCart).attr('data-variant-ids');
  var event = {
    event: 'Product ATC',
    purchaseType: purchaseType,
    purchaseLength: purchaseLength,
    purchaseVariant: purchaseVariant
  };
  dataLayer.push(event);
};

var triggerSuccessState = function triggerSuccessState(cart, $form, upsells) {
  // Update form
  if ($form.length) {
    var submitSelectors = dom.addToCart + ',' + dom.addPackToCart + ',' + dom.addMultipleToCart + ',[swap-original-product]';
    $form.find(submitSelectors).removeClass('is-loading').addClass('is-success');
    setTimeout(function () {
      $form.find(submitSelectors).removeClass('is-success').trigger('blur');
    }, 3000);
  }

  // GA tracking
  ATCEventGA(cart, $form);

  // Klaviyo tracking
  if (isProductTemplate()) {
    (0, _Klaviyo.klaviyoTrackItemAdd)();
  }

  // Setup upsell event
  window.addFinished = true;
  if (upsells) {
    var itemAddedEvent = new Event('addFinished');
    document.dispatchEvent(itemAddedEvent);
  }

  // Trigger inline cart
  if (!upsells) {
    $(document).trigger('inlinecart.open');
    if (isCartTemplate()) {
      (0, _Cart.updateCartUI)(cart);
    }
  }
};

var triggerErrorState = function triggerErrorState(err, $form) {
  // Update form
  if ($form.length) {
    var submitSelectors = dom.addToCart + ',' + dom.addPackToCart + ',' + dom.addMultipleToCart + ',[swap-original-product]';
    $form.find(submitSelectors).removeClass('is-loading').addClass('is-error');
    setTimeout(function () {
      $form.find(submitSelectors).removeClass('is-error').trigger('blur');
    }, 3000);
  }
  console.error(err);
};

var buildCartPermalink = function buildCartPermalink(ids, quantity, properties) {
  var idParams = ids.reduce(function (queryString, id, index) {
    var displayAnd = index === 0 ? '' : '&';
    // return the existing query string, the '&' connector if not on the first item, and the new product ID with its properties
    return '' + queryString + displayAnd + 'id[]=' + id;
  }, '');

  var propertiesParams = Object.keys(properties).reduce(function (allProperties, propertyKey) {
    var property = properties[propertyKey];
    return allProperties + '&properties[' + propertyKey + ']=' + property;
  }, '');

  return encodeURI('/cart/add?' + idParams + propertiesParams + '&quantity=' + quantity);
};

var generateRandomPackId = function generateRandomPackId() {
  /* Returns a random integer between min (inclusive) and max (inclusive) */
  var max = 99999;
  var min = 0;
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

var hasActiveSubscriptionId = function hasActiveSubscriptionId(props) {
  return props.hasOwnProperty('subscription_id') && props.subscription_id !== false;
};

var hasSubscriptionAvailable = function hasSubscriptionAvailable() {
  var $subscriptionIdInput = $('main ' + dom.propertyInput + '.is-recharge-input[name="properties[subscription_id]"]');
  var $parent = $subscriptionIdInput.closest('[subscription-option]');
  if ($parent.hasClass('is-hidden')) {
    return false;
  }
  return $subscriptionIdInput.length > 0 && JSON.parse($subscriptionIdInput.val()) !== false;
};

var isPDP = function isPDP() {
  return $(dom.body).hasClass('template__product');
};

// Need to ensure there isn't a mini deodorant in the cart by itself.
var removeLoneMiniDeodorant = exports.removeLoneMiniDeodorant = function removeLoneMiniDeodorant(cart) {
  var _cart$items = cart.items,
      items = _cart$items === undefined ? false : _cart$items;

  if (!items) return false;
  var cartContainsMini = false;
  var cartContainsRegProduct = false;
  var minisToRemove = items.reduce(function (obj, item) {
    var vendorLower = item.vendor.toLowerCase();
    if (vendorLower === 'mini' || vendorLower.indexOf('travel') !== -1) {
      cartContainsMini = true;
      obj[item.key] = 0;
    } else {
      cartContainsRegProduct = true;
    }
    return obj;
  }, {});
  if (cartContainsMini && !cartContainsRegProduct) {
    return minisToRemove;
  }
};

var getCartTotal = function getCartTotal(cart) {
  return cart.items.reduce(function (price, item) {
    if (!Object.keys(window.bva.giftProducts).includes(item.product_id.toString())) {
      price += item.line_price;
    }
    return price;
  }, 0);
};

var getCartItemCount = function getCartItemCount(cart) {
  var countedPacks = [];
  return cart.items.reduce(function (count, item) {
    var _item$properties = item.properties,
        properties = _item$properties === undefined ? false : _item$properties;

    var _ref11 = properties || {},
        pack_id = _ref11.pack_id;
    // Only count pack parent


    if (properties && pack_id) {
      if (countedPacks.indexOf(pack_id) === -1 && item.price === 0) {
        countedPacks.push(pack_id);
        count += item.quantity;
      }
    } else {
      count += item.quantity;
    }
    return count;
  }, 0);
};

var updateCart = exports.updateCart = function () {
  var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(cart) {
    var _cart$items2, items, codeName, code, totalPrice, updateGroup1, updateGroup2, updateGroup3, updateGroup4, updates;

    return _regenerator2.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _cart$items2 = cart.items, items = _cart$items2 === undefined ? false : _cart$items2;

            if (!items) {
              _context11.next = 17;
              break;
            }

            window.bva.cart = cart;
            codeName = _jsCookie2.default.getJSON('bva-cart-coupon-code') || false;
            code = _jsCookie2.default.getJSON('bva-cart-coupon-code-data') || false;
            totalPrice = getCartTotal(cart);

            $(dom.cartItemCount).attr('cart-item-count', getCartItemCount(cart));
            $(dom.cartItemCount).attr('cart-item-count-true', cart.item_count);
            $(dom.cartPrice).html((0, _Helpers.formatMoney)(totalPrice));

            // Get any validation updates from each check
            _context11.next = 11;
            return (0, _CartCodes.updateDiscountUI)(totalPrice, code, codeName);

          case 11:
            updateGroup1 = _context11.sent;
            updateGroup2 = removeLoneMiniDeodorant(cart);
            updateGroup3 = (0, _CartCodes.checkCartGifts)(cart);
            updateGroup4 = (0, _Cart.removeEmptyPacks)(cart);

            // Create singlular update map

            updates = Object.assign({}, updateGroup1, updateGroup2, updateGroup3, updateGroup4);

            // Only update the cart if validation changes are neccessary/found

            if (Object.keys(updates).length) {
              cartUpdate(updates).catch(console.error);
            }

          case 17:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, undefined);
  }));

  return function updateCart(_x25) {
    return _ref12.apply(this, arguments);
  };
}();

var getSwapItemsToRemove = function getSwapItemsToRemove(mostRecentCartItem, originalQty) {
  var updateMap = {};
  var properties = mostRecentCartItem.properties || false;
  var removePackById = properties.pack_id || false;
  // Remove pack
  if (removePackById) {
    updateMap = window.bva.cart.items.reduce(function (map, item) {
      if (item.properties !== null) {
        var _item$properties$pack = item.properties.packId,
            packId = _item$properties$pack === undefined ? false : _item$properties$pack;

        if (packId && packId === removePackById) {
          map[item.key] = item.quantity - parseInt(originalQty, 10);
        }
      }
      return map;
    }, {});
    // Remove single
  } else {
    updateMap[mostRecentCartItem.key] = mostRecentCartItem.quantity - parseInt(originalQty, 10);
  }

  return updateMap;
};

var getSwapAddFunc = function getSwapAddFunc($form) {
  var $btn = $form.find('button');
  var func = false;
  var addId = $btn.attr('data-variant-id') || false;
  var addPackIds = $btn.attr('data-variant-ids') || false;
  // Add pack
  if (addPackIds) {
    var ids = $btn.attr('data-variant-ids') || false;
    var packTitle = $btn.attr('pack-title') || false;
    var maxPackItems = parseInt($btn.attr('data-item-count'));
    var newQty = parseInt($btn.attr('data-qty')) || 1;
    $btn.addClass('is-loading');
    if (addPackIds) {
      var packIds = addPackIds.split(',');
      if (packIds.length == maxPackItems) {
        var uniqueIds = [].concat((0, _toConsumableArray3.default)(new Set(packIds))).length;
        var props = { pack: packTitle, pack_id: generateRandomPackId(), pack_count: uniqueIds };
        props = getProperties($form, props);
        func = function func() {
          return cartAddPack(packIds, newQty, props);
        };
      }
    }
    // Add single
  } else {
    var variantId = $btn.attr('data-variant-id') || false;
    var _newQty = parseInt($btn.attr('data-qty')) || 1;
    $btn.addClass('is-loading');
    if (variantId) {
      var _props = getProperties($form, _props);
      func = function func() {
        return cartAdd(variantId, _newQty, _props);
      };
    }
  }
  return func;
};

var cartSwap = function cartSwap(event) {
  // Remove event listener - only fire once (per swap)
  document.removeEventListener('addFinished', cartSwap);
  event.preventDefault();
  var $this = $(event.target);
  var $form = $this.closest('form');
  var originalQty = $('[pdp-atc]').attr('data-qty') || 1;
  var mostRecentCartItem = window.bva.cart.items[0];

  var removeItemUpdateMap = getSwapItemsToRemove(mostRecentCartItem, originalQty);
  var addFunc = getSwapAddFunc($form);

  if (addFunc) {
    cartUpdate(removeItemUpdateMap).then(addFunc).then(function (cart) {
      return triggerSuccessState(cart, $form);
    }).catch(function (err) {
      return triggerErrorState(err, $form);
    });
  }
};

var getUpsellHandle = function getUpsellHandle($btn, props) {
  var upsellHandle = false;
  var upsellSubscription = $btn.attr('data-upsell-subscription') || false;
  var upsellNonSubscription = $btn.attr('data-upsell-non-subscription') || false;
  // Upsell Custom (Subscription)
  if (isPDP() && hasActiveSubscriptionId(props) && upsellSubscription) {
    upsellHandle = upsellSubscription;
  }
  // Upsell Custom (Non-Subscription)
  else if (isPDP() && !hasActiveSubscriptionId(props) && upsellNonSubscription) {
      upsellHandle = upsellNonSubscription;
    }
    // Upsell (One-time > Subscription)
    else if (isPDP() && !hasActiveSubscriptionId(props) && hasSubscriptionAvailable()) {
        upsellHandle = window.bva.product.handle;
      }
  return upsellHandle;
};

var bindUIActions = function bindUIActions() {
  (0, _Upsell.bindUIActions)();

  $(document).on('click', dom.addToCart, function (event) {
    window.addFinished = false;
    event.preventDefault();
    var $this = $(event.currentTarget);
    var $form = $this.closest('form');
    var variantId = $this.attr('data-variant-id') || false;
    var qty = $this.attr('data-qty') || 1;
    $this.addClass('is-loading');

    if (variantId) {
      var props = getProperties($form, props);
      var skipUpsell = $this.hasClass('skip-upsell');
      var upsellHandle = skipUpsell ? false : getUpsellHandle($this, props);

      // Add item
      cartAdd(variantId, qty, props).then(function (cart) {
        return triggerSuccessState(cart, $form, upsellHandle);
      }).catch(function (err) {
        return triggerErrorState(err, $form);
      });

      // Trigger upsell
      if (upsellHandle) {
        if (upsellHandle === window.bva.product.handle) {
          (0, _SubscriptionUpsell.setupUpsellModalContent)(upsellHandle);
        } else {
          (0, _Upsell.setupUpsellModalContent)(upsellHandle);
        }
      }
    } else {
      alert('No variant selected.');
      triggerErrorState('[BVA] Missing Variant ID', $form);
    }
  });

  $(document).on('click', dom.addPackToCart, function (event) {
    window.addFinished = false;
    event.preventDefault();
    var $this = $(event.currentTarget);
    var $form = $this.closest('form');
    var qty = parseInt($this.attr('data-qty')) || 1;
    var ids = $this.attr('data-variant-ids') || false;
    $this.addClass('is-loading');

    if (ids) {
      var packIds = ids.split(',');
      var maxPackItems = parseInt($this.attr('data-item-count'));
      if (packIds.length == maxPackItems) {
        var uniqueIds = [].concat((0, _toConsumableArray3.default)(new Set(packIds))).length;
        var packTitle = $this.attr('pack-title') || false;
        var props = { pack: packTitle, pack_id: generateRandomPackId(), pack_count: uniqueIds };
        props = getProperties($form, props);

        // Used only for travel-kit product
        // Do not allow user to add more than <maxPurchaseCount> items with type <maxPurchaeType>.
        var maxPurchaseCount = parseInt($this.attr('data-max-purchase')) || false;
        var maxPurchaseType = $this.attr('data-max-purchase-type') || false;
        if (maxPurchaseType) {
          var count = window.bva.cart.items.reduce(function (total, item) {
            if (item.product_type == maxPurchaseType) {
              total += item.quantity;
            }
            return total;
          }, 0);
          var expectedTotal = count + qty;
          if (expectedTotal > maxPurchaseCount) {
            $this.removeClass('is-loading');
            var initialText = $this.text();
            $this.text('Max ' + maxPurchaseCount);
            setTimeout(function () {
              triggerErrorState(null, $form);
              setTimeout(function () {
                $this.text(initialText);
              }, 200);
            }, 1000);
            return;
          }
        }

        // Get upsell
        var skipUpsell = $this.hasClass('skip-upsell');
        var upsellHandle = skipUpsell ? false : getUpsellHandle($this, props);

        // Add pack
        cartAddPack(packIds, qty, props).then(function (cart) {
          return triggerSuccessState(cart, $form, upsellHandle);
        }).catch(function (err) {
          return triggerErrorState(err, $form);
        });

        // Trigger upsell
        if (upsellHandle) {
          if (upsellHandle === window.bva.product.handle) {
            (0, _SubscriptionUpsell.setupUpsellModalContent)(upsellHandle);
          } else {
            (0, _Upsell.setupUpsellModalContent)(upsellHandle);
          }
        }
      }
    } else {
      alert('No pack selected.');
      triggerErrorState('[BVA] Missing Pack Variant IDs', $form);
    }
  });

  $(document).on('click', dom.addMultipleToCart, function (event) {
    event.preventDefault();
    var $this = $(event.currentTarget);
    var $form = $this.closest('form');
    var items = $this.attr('data-items') || false;
    items = JSON.parse(items);
    $this.addClass('is-loading');

    cartAddMultiple(items).then(function (cart) {
      return triggerSuccessState(cart, $form);
    }).catch(function (err) {
      return triggerErrorState(err, $form);
    });
  });

  $(document).on('click', '[swap-original-product]', function (event) {
    event.preventDefault();
    if (!window.addFinished) {
      document.addEventListener('addFinished', cartSwap);
    } else {
      cartSwap(event);
    }
  });

  document.addEventListener('cart.updated', function (event) {
    var cart = event.detail || false;
    if (cart) updateCart(cart);
  });
};

var init = exports.init = function init() {
  bindUIActions();
  getCart().then(updateCart);
  console.log('[BVA] Component Loaded: AddToCart');
};